import React from 'react';
import {TextInput, Create, SimpleForm, required, minLength,BooleanInput, SaveButton, DeleteButton, ReferenceInput, SelectInput} from 'react-admin';
import {makeStyles, Theme} from '@material-ui/core';
import BaseListActions from '../BaseListActions';
import {SERVICES, SERVICES_CATEGORIES,FIXED_COLUMN_CATEGORY} from '../../consts/Names';

const useStyles = makeStyles((theme: Theme) => ({
   formContainer: {
      width: '80%',
      padding: '0 1em 1em 1em'
   },
   textFld: {
      width: '300px',
      marginTop: '1em'
   }
}));

export const ServicesCreate = (props) => {
   const {theme, basePath} = props;
   const classes = useStyles(theme);

   return (
      <Create {...props} actions={<BaseListActions basePath={basePath} />}>
         <SimpleForm className={classes.formContainer} redirect="list">

               <TextInput className={classes.textFld} label="Slug" source={SERVICES.slug} />



               <TextInput className={classes.textFld} label="Name" source={SERVICES.name} />

            <ReferenceInput className={classes.textFld} label="Related Service category" source={SERVICES.service_category_id} reference="services_categories" validate={[required()]}>
               <SelectInput source={SERVICES_CATEGORIES.id} />
            </ReferenceInput>
         </SimpleForm>
      </Create>
   );
};
